import { $generateNodesFromDOM } from '@lexical/html';
import { MultilineElementTransformer } from '@lexical/markdown';
import { LexicalEditor, LexicalNode } from 'lexical';
import { $createHtmlNode, $isHtmlNode, HtmlNode } from '../../nodes/HtmlNode';

export const createHtmlTransformer = (editor: LexicalEditor): MultilineElementTransformer => ({
  type: 'multiline-element',
  dependencies: [HtmlNode],

  regExpStart: /^<html>$/,
  regExpEnd: /^<\/html>$/,

  export: (node: LexicalNode) => {
    if (!$isHtmlNode(node)) {
      return null;
    }

    const exportOutput = node.exportDOM(editor);
    if (!exportOutput?.element) {
      return null;
    }

    const htmlContent = (exportOutput.element as HTMLElement).innerHTML;

    const output: string[] = [];
    output.push('<html>');
    output.push(htmlContent);
    output.push('</html>');
    return output.join('\n');
  },

  replace: (parentNode, children, startMatch, endMatch, linesInBetween) => {
    if (!startMatch || !endMatch || !linesInBetween) {
      return;
    }

    const htmlString = linesInBetween.join('\n');
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const nodes = $generateNodesFromDOM(editor, doc);

    if (nodes.length === 0) {
      return;
    }

    const htmlNode = $createHtmlNode();
    htmlNode.append(...nodes);
    parentNode.append(htmlNode);

    htmlNode.selectEnd();
  },
});
